import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { FormControl, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { NotificationBar } from 'src/services/notification.service';

@Component({
  selector: 'app-veto-settings',
  templateUrl: './veto-settings.component.html',
  styleUrl: './veto-settings.component.scss'
})
export class VetoSettingsComponent {

  notificationBar: NotificationBar;
  vetoSettingsGroup = new FormGroup({
    mapPoolControl: new FormControl([], [this.exactlySevenSelected]),
  });
  workspaceID = "";

  constructor(private title: Title, private route: ActivatedRoute, private location: Location, private snackBar: MatSnackBar, private fireStorage: AngularFireStorage, private db: AngularFireDatabase) {
    this.notificationBar = new NotificationBar(snackBar);
  }

  ngOnInit() {  
    this.title.setTitle("Create Team - EsportsMS");
    this.route.paramMap.subscribe(params => {
      this.workspaceID  = this.location.path().split("/")[1];
    });
    this.loadMapPool();
  }

  exactlySevenSelected(control: FormControl) {
    const value = control.value;
    if (!value || value.length != 7) {
      return { invalidSelectionCount: true };
    }
    return null;
  }

  loadMapPool() {

  }
}
